module.exports = __webpack_public_path__ + "assets/img/settlement2.c09143ca.png";